export const TEST_API_URL = 'https://test.techpos.uk/api/v1';
export function backOfficeConfiguration(environment: Readonly<Record<string, unknown>>): { apiUrl: string; test: boolean } {
  const test = environment['VITE_TECHPOS_ENVIRONMENT'] === 'TEST';
  const value = environment['VITE_API_BASE_URL'];
  if (test && value !== TEST_API_URL) throw new Error('TEST Back Office requires its explicit TEST API URL');
  return { apiUrl: typeof value === 'string' ? value : '/api/v1', test };
}
export async function verifyBackOfficeTestEnvironment(baseUrl: string, fetcher: typeof fetch = fetch): Promise<void> {
  if (baseUrl !== TEST_API_URL) throw new Error('TEST Back Office refused this API URL');
  const response = await fetcher(`${baseUrl}/till/environment`, { credentials: 'omit', redirect: 'error', signal: AbortSignal.timeout(15_000) });
  if (!response.ok) throw new Error('TEST environment unavailable; administration is blocked');
  const result = await response.json() as { database?: unknown; purpose?: unknown };
  if (result.database !== 'techpos_test' || result.purpose !== 'PARALLEL_TEST') throw new Error('TEST database verification failed; administration is blocked');
}
export const backOfficeEnvironment = backOfficeConfiguration((import.meta as { readonly env: Readonly<Record<string, unknown>> }).env);
